import { SourceBasedExpression } from '../Expression.js';
export class NotExpression extends SourceBasedExpression {
    evaluate(visitor, localVariables) {
        const source = this.getSource().evaluate(visitor, localVariables);
        return !source;
    }
}
//# sourceMappingURL=NotExpression.js.map